import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { FileText, Zap, MapPin, BookOpen, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-173">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-accent/10 blur-[120px] rounded-full pointer-events-none" data-id="element-174" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-175">
        <FadeIn className="text-center mb-8" data-id="element-176">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-card border border-slate-800 font-medium text-slate-300 mb-6 text-[12px]" data-id="element-177">
            <span className="w-2 h-2 rounded-full bg-brand-accent animate-pulse" data-id="element-178"></span>
            🏪 LIBROFY.STORE™ | Todo tu estudio contable. Automatizado. Desde
            hoy.
          </div>

          <h2 className="text-brand-accent font-bold tracking-wider uppercase text-sm md:text-base mb-4" data-id="element-179"></h2>

          <h1 className="md:text-6xl lg:text-7xl font-extrabold mb-8 text-[20px]" data-id="element-180">
            Dejá de ser el{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-accent to-amber-300" data-id="element-181">
              contador barato.
            </span>
          </h1>

          <img src="https://cdn.magicpatterns.com/uploads/pZESborWpUtBxGgsg8fSrK/81bc9714-44ea-432d-937c-96c4a499f5af.png" alt="MegaPack Contador PRO — El sistema más completo para contadores" className="w-full max-w-sm mx-auto rounded-2xl mb-8" fetchPriority="high" loading="eager" width={384} height={384} decoding="async" style={{
          aspectRatio: '1/1'
        }} data-id="element-182" />

          <p className="md:text-2xl text-slate-300 mb-8 max-w-3xl mx-auto text-[14px]" data-id="element-183">
            Automatizá con IA, recuperá 15 horas semanales y duplicá tus
            honorarios en 90 días.
          </p>

          <p className="text-slate-400 mb-10 max-w-2xl mx-auto text-[0px]" data-id="element-184">
            Prompts listos + Macros + Protocolos de clientes + Multiplicador de
            honorarios. Sin buscar. Sin inventar. Sin perder domingos.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="flex flex-col items-center" data-id="element-185">
          <Button href="#pricing" size="xl" className="mb-6 group" data-id="element-186">
            💥 QUIERO MI MEGAPACK CONTADOR PRO AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-slate-400 mb-12" data-id="element-187">
            <div className="flex items-center gap-1.5" data-id="element-188">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-189" /> Garantía 45
              días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-190">
              <Lock className="w-4 h-4 text-brand-accent" data-id="element-191" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-192">
              <CreditCard className="w-4 h-4 text-brand-accent" data-id="element-193" /> Mercado Pago
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-194">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-brand-card/50 border border-slate-800 p-6 rounded-2xl backdrop-blur-sm" data-id="element-195">
            <div className="flex flex-col items-center text-center gap-2" data-id="element-196">
              <FileText className="w-6 h-6 text-brand-accent" data-id="element-197" />
              <span className="font-medium" data-id="element-198">100% PDF</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-199">
              <Zap className="w-6 h-6 text-brand-accent" data-id="element-200" />
              <span className="font-medium" data-id="element-201">Acceso en 5 min</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-202">
              <MapPin className="w-6 h-6 text-brand-accent" data-id="element-203" />
              <span className="font-medium" data-id="element-204">Para Argentina</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-205">
              <BookOpen className="w-6 h-6 text-brand-accent" data-id="element-206" />
              <span className="font-medium" data-id="element-207">6 Tomos Completos</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}